<template>
  <div>
    <Form ref="searchForm" inline :label-width="70">
      <Form-item label="题库分类">
        <Cascader
          :data="catagoris"
          v-model="classify_ids"
          change-on-select
          style="width:200px;"
        ></Cascader>
      </Form-item>
      <Form-item label="题库名称">
        <Input
          style="width:200px"
          placeholder="请输入题库名称关键字"
          v-model="searchCondition.name"
          clearable
          @keydown.native.enter="search(1)"
        />
      </Form-item>
      <Form-item class="search-form-btns">
        <div class="btn-wrap form-item-search">
          <Button icon="ios-search" @click="search(1)">搜索</Button>
          <Button icon="md-undo" @click="search(0)">重置</Button>
        </div>
      </Form-item>
    </Form>
    <div>
      <Button type="primary" @click="createBank">新增题库</Button>
      <Checkbox v-model="onlyShowMine" @on-change="onMineChange" style="margin-left:20px;">只看我创建的</Checkbox>
    </div>
    <div class="content">
      <Grid
        ref="grid"
        :columns="columns"
        data-url="/api/ques/bank"
        :search="searchCondition"
        :rowsFormatter="rowsFormatter"
        @onSelectionChange="onSelectionChange"
        selectType="multi"
        keyField="id"
        method="get"
      >
        <template slot-scope="{ row }" slot="action">
          <Button
            type="text"
            size="small"
            :to="{name:'QuestionBankTopic',query:{id:row.id,reload:1}}"
          >管理试题-</Button>
          <Button type="text" size="small" @click="editBank(row.id)">编辑-</Button>
          <Button type="text" size="small" @click="deleteBank(row)">删除</Button>
        </template>
        <template slot="footer-left">
          <Button
            class="btn-margin-right"
            type="text"
            :disabled="selectList.length == 0"
            @click="batchDelete"
          >删除</Button>
        </template>
      </Grid>
    </div>
    <Modal v-model="showCreate" :title="bankInfo.id?'编辑题库':'新增题库'" ref="modal">
      <Form ref="bankForm" :rules="ruleValidate" :model="bankInfo" :label-width="80">
        <FormItem label="题库名称" prop="name">
          <Input style="width:300px" type="text" v-model="bankInfo.name" :maxlength="15" />
        </FormItem>
        <FormItem label="所属分类" prop="classify_ids">
          <Cascader
            :data="bankInfo.catagoris"
            trigger="hover"
            v-model="bankInfo.classify_ids"
            style="width:200px;"
            change-on-select
          ></Cascader>
        </FormItem>
        <FormItem label="可见范围">
          <Checkbox v-model="bankInfo.scope">仅创建人和超级管理员可查看管理使用</Checkbox>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button @click="showCreate = false">取消</Button>
        <Button type="primary" @click="save">确定</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
export default {
  name: "QuestionBankManage",
  data() {
    return {
      catagoris: [],
      classify_ids: [],
      searchCondition: {
        name: "",
        classify: "",
        uid: ""
      },
      onlyShowMine: false,
      showCreate: false,
      columns: [
        {
          title: "题库名称",
          key: "name",
          minWidth: 200
        },
        {
          title: "所属分类",
          key: "classify",
          minWidth: 150
        },
        {
          title: "题目数",
          key: "ques_amount",
          minWidth: 100
        },
        {
          title: "创建人",
          key: "creator",
          minWidth: 120
        },
        {
          title: "更新时间",
          key: "updated_at_time",
          minWidth: 150
        },
        {
          title: "操作",
          slot: "action",
          width: 240,
          align: "center",
          fixed: "right"
        }
      ],
      bankInfo: {
        id: "",
        name: "",
        catagoris: [],
        classify_ids: [],
        scope: false
      },
      ruleValidate: {
        name: [
          {
            required: true,
            message: "题库名称不能为空",
            trigger: "blur"
          }
        ],
        classify_ids: [
          {
            required: true,
            message: "所属分类必须选择",
          }
        ]
      },
      selectList: []
    };
  },
  async created() {
    let catagoris = await this.$http.get("/api/course/classify");
    catagoris.forEach(c => {
      c.value = c.id;
      c.label = c.name;
      c.children = c.children || [];
      c.children.forEach(child => {
        child.value = child.id;
        child.label = child.name;
      });
    });
    this.catagoris = catagoris;
    this.bankInfo.catagoris = catagoris;
  },
  methods: {
    rowsFormatter(rows) {
      rows.forEach(row => {
        if (row.updated_at) {
          row.updated_at_time = new Date(
            parseInt(row.updated_at) * 1000
          ).format("yyyy-MM-dd hh:mm:ss");
        }
      });
    },
    onSelectionChange(list) {
      this.selectList = list;
    },
    async deleteBank(row) {
      if (row.ques_amount > 0) {
        await this.$promiseAlert("当前题库已被使用，无法删除", {
          type: "warning"
        });
        return;
      }
      await this.$promiseConfirm("确定要删除该题库吗？");
      await this.$http.delete("/api/ques/bank/" + row.id);
      this.$refs.grid.refresh();
    },
    async batchDelete() {
      let ids = [];
      for (let i = 0; i < this.selectList.length; i++) {
        let bank = this.selectList[i];
        if (bank.ques_amount > 0) {
          await this.$promiseAlert("已选题库中有题库含有试题，无法删除", {
            type: "warning"
          });
          return;
        }
        ids.push(bank.id);
      }
      await this.$promiseConfirm("确定要批量删除已选题库吗？");
      await this.$http.delete("/api/ques/bank/" + ids.join(","));
      this.$refs.grid.refresh();
      this.selectList = [];
    },
    async save() {
      this.$refs.bankForm.validate(async valid => {
        if (!valid) {
          return;
        }
        let data = {
          name: this.bankInfo.name,
          classify_id: this.bankInfo.classify_ids[1] || this.bankInfo.classify_ids[0] ,
          scope: this.bankInfo.scope ? 2 : 1
        };
        if (!this.bankInfo.id) {
          await this.$http.post("/api/ques/bank", data);
          this.showCreate = false;
          await this.$refs.grid.searchRefresh();
        } else {
          await this.$http.put("/api/ques/bank/" + this.bankInfo.id, data);
          this.showCreate = false;
          await this.$refs.grid.refresh();
        }
      });
    },
    createBank() {
      this.showCreate = true;
      this.bankInfo.id = "";
      this.bankInfo.name = "";
      this.bankInfo.classify_ids = [];
      this.bankInfo.scope = false;
    },
    async editBank(id) {
      let data = await this.$http.get("/api/ques/bank/" + id);
      this.bankInfo.id = id;
      this.bankInfo.name = data.name;
      this.bankInfo.scope = data.scope == 2;
      let catagoris = this.bankInfo.catagoris;
      for (let i = 0; i < catagoris.length; i++) {
        let catagory = catagoris[i];
        let c = 0;
        for (; c < catagory.children.length; c++) {
          let child = catagory.children[c];
          if (child.id == data.classify_id) {
            this.bankInfo.classify_ids = [catagory.id, child.id];
            break;
          }
        }
        if (c < catagory.children.length) {
          break;
        }
      }
      this.showCreate = true;
    },
    search(flag) {
      if (flag == 0) {
        this.searchCondition.name = "";
        this.classify_ids = [];
        this.searchCondition.classify = "";
        this.searchCondition.uid = "";
      } else {
        if (this.classify_ids.length > 0) {
          this.searchCondition.classify = this.classify_ids[
            this.classify_ids.length - 1
          ];
        } else {
          this.searchCondition.classify = "";
        }
        this.searchCondition.uid = this.onlyShowMine
          ? this.$store.state.user.id
          : "";
      }
      this.$refs.grid.searchRefresh();
    },
    async onMineChange() {
      await this.search(1);
    }
  }
};
</script>
